<template>
  <v-container class="login-container" fluid>
    <v-row style="height: 100%; margin:0px">
      <v-col cols="12" md="6" lg="8" class="bottom-gradient hidden-sm-and-down">
      </v-col>
      <v-col cols="12" md="6" lg="4" class="input_section position-relative">
        <v-card
          class="mr-0 my-0 py-0 input_section input_gradient h-100 align-center justify-center d-flex flex-column"
          style="padding-left: 30px; padding-right: 30px;"
        >
          <v-card-title class="justify-center pt-14">
            <v-img :src="logo" width="287" height="49" contain />
          </v-card-title>
          <v-card-title class="mx-3 mt-14">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="email"
                  label="Email Address"
                  dense
                  rounded
                  filled
                  background-color="white"
                  class="mt-3"
                  @change="onChange"
                  full-width
                  hide-details
                  type="email"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  @change="onChange"
                  @keyup.enter="loginClicked"
                  label="Password"
                  dense
                  rounded
                  filled
                  full-width
                  background-color="white"
                  class="pb-0 mb-0"
                />
                <v-alert type="error" v-if="errorMessage">
                  {{ errorMessage }}
                </v-alert>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-title class="justify-center">
            <v-btn
              rounded
              color="#24a69a"
              @click="loginClicked"
              :loading="loading"
              dark
              class="px-5"
              >Log In</v-btn
            >
          </v-card-title>
          <v-card-title class="justify-center">
            <v-btn
              text
              class="text-none mb-4"
              rounded
              color="white"
              small
              @click="goToForgotPassword"
              >Forgot your password?</v-btn
            >
          </v-card-title>
          <v-card-text
            class="justify-center align-center d-flex"
            style="font-weight:bold; font-style: italic; color: white;"
          >
            OR
          </v-card-text>
          <v-card-title class="justify-center d-flex mb-15">
            <v-btn
              color="#0a5b8a"
              class="mb-4"
              rounded
              dark
              small
              @click="gotoVolunteerRegister"
              >Register as a Volunteer</v-btn
            >
            <v-btn
              color="#0a5b8a"
              class="mb-4 ml-4"
              rounded
              dark
              small
              @click="gotoAgencyRegister"
              >Join as an Agency</v-btn
            >
            <v-btn
              color="#0a5b8a"
              class="mb-4 ml-4"
              rounded
              dark
              small
              @click="gotoBusinessRegister"
              >Join as Business</v-btn
            >
            
          </v-card-title>
          <v-card-text
            class="position-absolute d-flex align-center justify-center"
            style="bottom: 0;"
          >
            <div class="d-flex flex-wrap" v-if="$vuetify.smAndUp">
              <div class="white--text url-button font-10" @click="goToAboutUs">
                About us
              </div>
              <div
                class="white--text url-button font-10 ml-3"
                @click="goToPrivacy"
              >
                Privacy and policy
              </div>
              <div class="white--text url-button font-10 ml-3" @click="goToTOS">
                Terms of service
              </div>
              <div class="white--text url-button font-10 ml-3" @click="goToChildSupport">
                Child Support
              </div>
              <div class="white--text font-10 font-bold ml-3">
                © {{ new Date().getFullYear() }} {{appTitle}}
              </div>
              <div class="white--text font-10 ml-3">All right reserved</div>
            </div>
            <div class="d-flex flex-column" v-else>
              <div class="d-flex flex-wrap">
                <div
                  class="white--text url-button font-10"
                  @click="goToAboutUs"
                >
                  About us
                </div>
                <div
                  class="white--text url-button font-10 ml-3"
                  @click="goToPrivacy"
                >
                  Privacy and policy
                </div>
                <div
                  class="white--text url-button font-10 ml-3"
                  @click="goToTOS"
                >
                  Terms of service
                </div>
                <div class="white--text url-button font-10 ml-3" @click="goToChildSupport">
                Child Support
              </div>
              </div>
              <div class="d-flex flex-row">
                <div class="white--text font-10 font-bold mr-3">
                  © {{ new Date().getFullYear() }} {{appTitle}}
                </div>
                <div class="white--text font-10 ml-3">All right reserved</div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import { messaging, getToken } from "../../firebaseconfig"; // Import messaging and getToken

export default {
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      errorMessage: null,
      rules: {
        required: value => !!value || "Required.",
        min: v => (v && v.length >= 6) || "Min 6 characters",
        passwordMatch: () =>
          this.profile.password != this.profile.confirmPassword
            ? `Password doesn't match`
            : ""
      },
      showPassword: false,
      fcmToken: null
    };
  },
    computed: {
    logo() {
      // resolve the logo file based on .env string
      return require(`@/assets/${process.env.VUE_APP_LOGO}`);
    },
        appTitle() {
      return process.env.VUE_APP_TITLE;
    }
  },
  methods: {
    ...mapActions({
      onLogin: "auth/onLogin",
      getRegionSettings: "usersetting/getRegionSettings"
    }),
    loginClicked() {
      if (this.loading) return;
      const params = {
        email: this.email,
        password: this.password,
        rememberme: true,
        fcm_token: this.fcmToken
      };
      this.loading = true;
      this.onLogin(params)
        .then(type => {
          this.loading = false;
          this.emailError = null;
          this.passwordError = null;
          this.getRegionSettings();
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
          } else if (type == "Admin") {
            this.$router.push({ name: "admin-home" });
          } else if (type == "Agency") {
            this.$router.push({
              name: "agency-home",
              query: { welcome: true }
            });
          } else if (type == "Volunteer") {
            this.$router.push({
              name: "volunteer-home",
              query: { welcome: true }
            });
          } else if (type == "Company") {
            this.$router.push({
              name: "company-home",
              query: { welcome: true }
            });
          } else {
            this.errorMessage = "unknown user type";
          }
        })
        .catch(error => {
          this.loading = false;
          this.errorMessage = error.message;
        });
    },
    onChange() {
      this.errorMessage = null;
    },
    gotoVolunteerRegister() {
      this.$router.push({ name: "user-register" });
    },
    gotoAgencyRegister() {
      this.$router.push({ name: "agency-register" });
    },
    gotoBusinessRegister() {
      this.$router.push({ name: "business-register" });
    },
    goToForgotPassword() {
      this.$router.push({ name: "forgot-password" });
    },
    goToAboutUs() {
      this.$router.push({ name: "aboutus" });
    },
    goToPrivacy() {
      this.$router.push({ name: "privacy" });
    },
    goToTOS() {
      this.$router.push({ name: "terms-of-service" });
    },
        goToChildSupport() {
      this.$router.push({ name: "child-support" });
    },
    
    requestNotificationPermission() {
      if (Notification.permission === "granted") {
        this.getFCMToken();
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            this.getFCMToken();
          }
        });
      }
    },
    getFCMToken() {
      getToken(messaging, {
        vapidKey:
          "BGf52oMSBRe6pmItle-a-RaWDPNgxzXk2GTOqUHQSGR6NhpQuOyJb-oy4HcUV6BeW0CeCkQmaVYZCYcZ1iGg1Cw"
      })
        .then(currentToken => {
          if (currentToken) {
            console.log("FCM Token:", currentToken);
            this.fcmToken = currentToken;
            // Send the token to your server or save it in the local storage
          } else {
            console.log(
              "No registration token available. Request permission to generate one."
            );
          }
        })
        .catch(err => {
          console.log("An error occurred while retrieving token. ", err);
        });
    }
  },
  mounted() {
    this.requestNotificationPermission();
  }
};
</script>
<style scoped>
.welcome-title {
  font-family: "Poppins-Bold";
  font-size: 70px;
  text-shadow: 2px 2px 12px #0006;
  color: #472583;
  margin-left: 50px;
  margin-top: 60%;
  margin-bottom: 10px;
  display: block;
}
.welcome-description {
  font-family: "Poppins-Medium";
  font-size: 20px;
  margin-left: 50px;
  color: #240a52;
  display: block;
}
.login-container {
  /* position: absolute; */
  bottom: 0;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}

.bottom-gradient {
  background-image: url(../../assets/bg_login.jpg);
  background-size: cover;
  background-position: 50% 50%;
  /* position: absolute; */
  bottom: 0;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
}
.login_img {
  -webkit-filter: drop-shadow(1px 8px 12px rgba(0, 0, 0, 0.4));
  filter: drop-shadow(1px 8px 12px rgba(0, 0, 0, 0.4));
  margin-top: 70%;
}
.input_section {
  height: 100%;
  padding: 0px;
}

.input_gradient {
  background: linear-gradient(
    112deg,
    rgba(36, 163, 154, 0.8) -20.67%,
    rgba(157, 189, 208, 0.45) 33.07%,
    rgba(8, 68, 104, 0.8) 100.72%
  );
  background-blend-mode: multiply;
}
</style>
